import { registerQuery } from 'data-fetching-client';
import { getSeatRequestsAdminRpc } from 'growth-monetization-service-types';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
export const GET_SEAT_REQUESTS_ADMIN = registerQuery({
  fieldName: 'requestedSeatsForAdmin',
  fetcher() {
    const client = createRpcClientV2({
      hubHttpClient: http
    });
    return client.call(getSeatRequestsAdminRpc, {
      queryParameters: undefined,
      pathParameters: undefined
    });
  }
});